import { styled } from '@mui/material';

export const sxStyles = {
  title: {
    marginBottom: '1rem',
  },
  subtitles: {
    marginBottom: '1rem',
  },
};

export const StyledHeroSection = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'end',
  maxWidth: '1320px',
  margin: '0 auto',
  position: 'relative',

  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
    justifyContent: 'center',
  },
}));

export const StyledHeroText = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '660px',
  width: '100%',
  minHeight: 'auto',
  padding: '1.25rem',

  [theme.breakpoints.up('xs')]: {
    minHeight: '440px',
  },
}));

export const StyledButtonsWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  gap: '0.5rem',
  marginTop: '1rem',
  marginBottom: '2rem',

  '& > a:first-of-type': {
    marginRight: '0.5rem',
  },

  [theme.breakpoints.up('xs')]: {
    justifyContent: 'start',
  },
}));

export const StyledHeroImg = styled('div')(({ theme }) => ({
  maxWidth: '850px',
  width: '100%',
  margin: '1.5rem auto 0 auto',

  img: {
    position: 'static',
    display: 'block',
    margin: '0 auto',
    borderBottomLeftRadius: '240px',
    maxHeight: '440px',
    height: '100%',
  },

  [theme.breakpoints.up('lg')]: {
    margin: '0',

    img: {
      position: 'relative',
      left: '74px',
    },
  },

  [theme.breakpoints.up('xl')]: {
    img: {
      position: 'relative',
      left: '256px',
    },
  },
}));
